// Small concurrent batches let available covers render without waiting for slower images.
async function loadAnalyticsCovers(ids, fetchBatch, publish, cancelled = () => false) {
  const remaining = [...new Set(ids)];
  async function worker() {
    while (remaining.length && !cancelled()) {
      const batch = remaining.splice(0, 4);
      try {
        const result = await fetchBatch(batch);
        if (!cancelled()) publish(result);
      } catch (error) {
        if (!cancelled()) publish({ covers: {}, errors: Object.fromEntries(batch.map(id => [id, `Cover request failed: ${error.message || 'error'}`])) });
      }
    }
  }
  await Promise.all([worker(), worker()]);
}
module.exports = { loadAnalyticsCovers };
